<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Default Table" pageTitle="Default Table" />
            <DefaultTable />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import DefaultTable from '../DefaultTable/DefaultTable'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'DefaultTablePage',
    components: {
        MainHeader,
        PageTitle,
        DefaultTable,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>